/**
 * UI Select Controller
 */
export class UiSelectCtrl {
    constructor($scope) {
        $scope.uiSelectOnRemove = () => $scope.$emit('uiSelectSearchChange', $scope.$select.search);
        $scope.uiSelectOnSelect = () => {
            $scope.$select.search = '';
            $scope.$emit('uiSelectSearchChange', $scope.$select.search);
        };

        let timer = null;

        $scope.$watch('$select.search', () => {
            //watch on the user free text input
            clearTimeout(timer);

            timer = setTimeout(function() {
                $scope.searchInput = $scope.$select.search;
                $scope.$emit('uiSelectSearchChange', $scope.$select.search);
            }, 500);
        });
    }
}
